import { formatCpapSerialWithDeviceNo } from "./cpapDeviceNumber";

export const normalizeReceiptLotNo = (value) => {
  if (value === null || value === undefined) return "";

  const lotNo = String(value).trim();
  return lotNo && lotNo !== "---" ? lotNo : "";
};

export const resolveCpapLotNo = (orderItemLotNo, productLotNo) =>
  normalizeReceiptLotNo(orderItemLotNo) ||
  normalizeReceiptLotNo(productLotNo);

export const formatCpapReceiptIdentification = (
  serialNumber,
  deviceNo,
  lotNo,
) => {
  const identification = formatCpapSerialWithDeviceNo(serialNumber, deviceNo);
  const normalizedLotNo = normalizeReceiptLotNo(lotNo);

  return [
    identification,
    normalizedLotNo ? `(${normalizedLotNo})` : "",
  ]
    .filter(Boolean)
    .join(" ");
};

export const formatCpapReceiptMaskLine = (
  packageAccessoryName,
  maskNameWithSize,
  lotText,
) =>
  [packageAccessoryName, maskNameWithSize, lotText]
    .map((value) =>
      value === null || value === undefined ? "" : String(value).trim(),
    )
    .filter(Boolean)
    .join("  ");

const getAccessoryReceiptLotNumbers = (allocations) => {
  const lotsByKey = new Map();

  (Array.isArray(allocations) ? allocations : []).forEach((allocation) => {
    const quantity = Number(allocation && allocation.quantity);
    const lotNo =
      normalizeReceiptLotNo(allocation && allocation.lotNo) ||
      normalizeReceiptLotNo(allocation && allocation.lotId);

    if (!lotNo || !Number.isFinite(quantity) || quantity <= 0) return;

    const lotKey = lotNo.toLowerCase();
    if (!lotsByKey.has(lotKey)) {
      lotsByKey.set(lotKey, lotNo);
    }
  });

  return Array.from(lotsByKey.values());
};

export const formatAccessoryReceiptLots = (allocations) => {
  const formattedLots = getAccessoryReceiptLotNumbers(allocations);

  return formattedLots.length > 0 ? `(${formattedLots.join(", ")})` : "";
};

export const formatCpapReceiptMaskLots = (allocations) => {
  const formattedLots = getAccessoryReceiptLotNumbers(allocations);

  return formattedLots.length > 0 ? `(${formattedLots.join(", ")})` : "";
};

export const splitSaleOrderReceiptItems = (items) => {
  const orderItems = Array.isArray(items) ? items : [];

  return {
    cpapItems: orderItems.filter((item) => item.productType === "CPAP"),
    accessoryItems: orderItems.filter((item) => item.productType !== "CPAP"),
  };
};

export const getStandaloneAccessoryReceiptItems = (
  items,
  accessoryPackageStatus,
) => {
  const orderItems = Array.isArray(items) ? items : [];
  const hasCpapItem = orderItems.some((item) => item.productType === "CPAP");

  return orderItems.filter((item, index) => {
    if (item.productType === "CPAP") return false;
    if (!hasCpapItem || item.productType !== "Mask") return true;

    const savedPackageStatus =
      accessoryPackageStatus && accessoryPackageStatus[index];
    const isIncludedInPackage =
      savedPackageStatus !== undefined
        ? savedPackageStatus === true
        : item.isIncludedInPackage === true;

    return !isIncludedInPackage;
  });
};
